"use client"

import {App, Divider, Input, Select as AntSelect} from "antd";
import {configConfirmModal} from "@/theme/config/confirmModalConfirm";
import {forwardRef, useEffect, useState} from "react";
import {useDebounce, useTempData} from "@/lib/hook";
import {api} from "@/lib/api/api";
import {SearchIcon} from "@/theme/assets/icons";
export const Select = forwardRef(({onChange, confirm, ...rest}) => {
    const {modal} = App.useApp();

    return (
        <>
            <AntSelect
                style={{
                    width: '100%',
                }}
                onChange={async (value, option) => {
                    if (confirm) {
                        modal.confirm(configConfirmModal({
                            ...confirm,
                            onOk: () =>{
                                if (onChange){
                                    onChange(value, option)
                                }
                            }
                        }))
                    } else {
                        if (onChange) {
                            onChange(value, option)
                        }
                    }
                }}
                {...rest}
            />
        </>
    );
})

const initFilterData = {
    page: 1,
    options: [],
    pagination: null,
}
export const PaginationItemSelect = ({optionsFilter, requestSearchName, requestFilter, routeName, requestDataName, transform, ...rest}) => {
    const {data, setTempData} = useTempData(`select.${requestDataName}`, initFilterData)
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState(null);
    const debounce = useDebounce(search, 500)

    useEffect(() => {
        loadData(debounce)
    }, [debounce])

    useEffect(() => {
        return () =>{
            loadData(null)
        }
    }, [])

    const onScroll = (event) => {
        const target = event.target;
        if (
            !loading &&
            target.scrollTop + target.offsetHeight === target.scrollHeight
        ) {
            target.scrollTo(0, target.scrollHeight);
            loadData()
        }
    }

    const loadData = (search) => {
        if (!data.pagination) {
            fetchData(search)
        } else if (data.pagination.total_pages !== (data.page - 1)) {
            fetchData(search)
        }
    }

    const fetchData = (search) => {
        setLoading(true);
        api.send({
            route: {name: routeName},
            data: {
                page: data.page,
                ...requestFilter,
                [requestSearchName]: search
            }
        })
            .then((resp) => {
                if (resp && resp.data) {
                    if (search && data.page === 1) {
                        setTempData({
                            ...data,
                            page: data.page + 1,
                            pagination: resp?.data?.meta?.pagination,
                            options: resp.data[requestDataName]
                                ? resp.data[requestDataName].map((item) => transform(item))
                                : []
                        })
                    } else {
                        setTempData({
                            ...data,
                            page: data.page + 1,
                            pagination:resp?.data?.meta?.pagination,
                            options: resp.data[requestDataName]
                                ? [
                                    ...data.options,
                                    ...resp.data[requestDataName].map((item) => transform(item))
                                ]
                                : []
                        })
                    }
                }
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const optionsOnSearch = (value) => {
        setTempData({
            ...data,
            page: 1,
        })
        setSearch(() => value || null)
    }

    const optionsFiltered = () => {
        if (data.options && optionsFilter){
            return optionsFilter(data.options)
        }
        return data.options
    }

    return (
        <>
            <Select
                style={{
                    width: '100%',
                }}
                loading={loading}
                onPopupScroll={onScroll}
                filterOption={false}
                showSearch={false}
                dropdownRender={(menu) => (
                    <>
                        <Input
                            placeholder="Search"
                            value={search}
                            onChange={(e)=>{
                                optionsOnSearch(e.target.value)
                            }}
                            suffix={(
                                <>
                                    <SearchIcon
                                        className={'input_icon'}
                                    />
                                </>
                            )}
                            onKeyDown={(e) => e.stopPropagation()}
                        />
                        <Divider
                            style={{
                                margin: '8px 0',
                            }}
                        />
                        {menu}
                    </>
                )}
                {...rest}
            >
                {optionsFiltered().map((el) => (
                    <AntSelect.Option
                        key={el.value}
                        {...el}
                    >
                        {el.label}
                    </AntSelect.Option>
                ))}
                {loading && <AntSelect.Option value={'load'}>Loading...</AntSelect.Option>}
            </Select>
        </>
    );
}